import React, { useEffect, useState } from "react";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../../translations/subMenuItems.json';
import commonTranslation from '../../../translations/common.json';
import type { ScreenSaver } from "../../../model/Veille";
import useVeille from '../../../redux/Hooks/Kiosk/useVeille';
import Button from "../../Common/Button";
import TextField from "./../TextField";
import { defaultTimeoutSeconds } from "../../../model/Configuration";

const ScreenSaverChange = (props:{
  data: ScreenSaver | undefined,
  saveData: Function
}) => {
  const locale = useLocale();
  const veille = useVeille();
  const [url, setUrl] = useState<string>(veille?.screenSaver?.source || '');
  const [timerToNextComponent, setTimerToNextComponent] = useState<number | undefined>(props.data?.timeBeforeSwitch || defaultTimeoutSeconds);
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    setChanged(true);
  }, [url, timerToNextComponent])

  useEffect(() => {
    setChanged(false);
  }, [])

  const handleChangeUrl = (event: React.FormEvent<HTMLInputElement>) => {
    setUrl(event.currentTarget.value);
  }

  const handleChangeTimer = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === '') {
      setTimerToNextComponent(undefined);
    } else {
      const val = parseInt(event.currentTarget.value);
      val && setTimerToNextComponent(parseInt(event.currentTarget.value));
    }
  }

  const handleApply = () => {
    props.data ?
      props.saveData({
        ...props.data,
        source: url,
        timeBeforeSwitch: timerToNextComponent || defaultTimeoutSeconds
      })
      :
      props.saveData({
        activated: false,
        source: url,
        timeBeforeSwitch: timerToNextComponent || defaultTimeoutSeconds
      })

      setChanged(false);
  }

  return (
    <div className="w-full flex flex-col border border-red-800 rounded-sm gap-1 my-1 px-4 py-2">
      <TextField
        label={translation[locale]?.veille.screensaverurl || translation["fr-FR"].veille.screensaverurl}
        onChange={handleChangeUrl}
        value={url}
      />
      <TextField
        label={translation[locale]?.veille.screensavertimer || translation["fr-FR"].veille.screensavertimer}
        onChange={handleChangeTimer}
        value={timerToNextComponent}
      />
      {changed &&
        <div className="flex justify-center mt-1">
          <Button
            onClick={handleApply}
            label={commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          >
            {commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          </Button>
        </div>
      }
    </div>
  );
};

export default ScreenSaverChange;
